"use client";
import { useSearchParams } from "next/navigation";
import { Product, ProductVariant } from "@/lib/medusa/types";
import Price from "@/components/price";

export default function ProductPrice({ product }: { product: Product }) {
  const searchParams = useSearchParams();

  const variant = product.variants.find((variant: ProductVariant) =>
    variant.selectedOptions.every(
      (option) => option.value === searchParams?.get(option.name.toLowerCase())
    )
  );
  return (
    <div className="mr-auto w-auto rounded-full bg-blue-600 p-2 text-sm text-white">
      <Price
        amount={(variant?.price || product.priceRange.maxVariantPrice).amount}
        currencyCode={
          (variant?.price || product.priceRange.maxVariantPrice).currencyCode
        }
      />
    </div>
  );
}
